<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="800px"
    top="1%"
    title="关于考试作弊举报的相关事宜"
    class="about-dialog btn-close"
    :before-close="onCancel"
  >
    <div>
      <div>
        很遗憾，小部分同学希望得到面试、offer的机会是通过投机取巧来获取的。这对于用心准备、诚信作答的同学来说是极大的不公平。
      </div>
      <div style="padding-top: 20px">
        顺应广大同学及企业的要求，我们开放举报邮箱
        <span class="red">exam@acmcoder.com</span>
        ，同学可以将有作弊嫌疑的相关信息在考试结束后
        <span class="red">24小时</span>
        内发送到这个邮箱里，我们会根据您提供的信息结合考试监控及考试数据来进行核对，发现确实存在的作弊行为，将及时反馈给招聘企业进行下一步处理。
      </div>
      <div style="padding-top: 20px">希望同学的举报信息能包含以下内容：</div>
      <div style="padding-top: 20px">
        1.标题：“
        <span class="red"
          >作弊举报+xxxx（企业名称）20XX校招XX.xx（考试日期）+作弊者信息（姓名、邮箱或手机号，越详细越能尽快定位到作弊考生）</span
        >
        ”
      </div>
      <div>
        2.内容：描述作弊行为，例如：<span class="red"
          >选择题协作、编程题分享代码</span
        >
        等。
      </div>
      <div>
        3.图片：微信、qq等通讯工具的截图（
        <span class="red"
          >由于通讯工具个人信息多采用个性昵称，希望同学提供的材料能标示出对应的真实信息—姓名手机号等</span
        >
        ）、作弊现场照片（ <span class="red">手机查询信息、多人作答等</span> ）
      </div>
      <div style="padding-top: 20px">
        我们承诺您的信息不会泄露给任何个人及企业机构，请您在发现作弊行为时，主动维护自己的权益。
      </div>
      <div style="padding-top: 20px">
        希望和所有诚信的同学一起维护公平的评选环境。
      </div>
      <div>举报邮箱：<span class="red">exam@acmcoder.com</span></div>
      <div style="padding-top: 20px">赛码网</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <a type="primary" class="btn" @click="onCancel">我知道了</a>
    </span></el-dialog
  >
</template>
<script>
export default {
  name: 'about-dialog',
  props: ['dialogVisible'],
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
<style lang='scss' scoped>
.about-dialog {
  font-size: 14px;
  line-height: 25px;
  padding: 20px;
  letter-spacing: 2px;

  .red {
    color: rgb(192, 0, 0);
    font-weight: bold;
  }
}
</style>
<style>
.about-dialog .el-dialog__header {
  border-bottom: 1px solid #eded;
}
</style>


// WEBPACK FOOTER //
// src/components/about/about-dialog/index.vue